<template>
  <div class="communityConfig">
    <div class="width-75">
      <Form
        ref="project"
        :model="project"
        :rules="ruleValidate"
        :label-width="150"
        label-colon
      >
        <!-- 项目名称 -->
        <FormItem prop="name" :label="$t('check.projectName')">
          <Input
            v-model="project.name"
            :placeholder="$t('check.projectNameTip')"
            size="large"
            maxlength="50"
            clearable
          ></Input>
        </FormItem>
        <!-- 项目描述 -->
        <FormItem prop="description" :label="$t('check.describe')">
          <Input
            v-model="project.description"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 6 }"
            :placeholder="$t('check.contentTip')"
            size="large"
            clearable
            maxlength="1024"
          ></Input>
        </FormItem>
        <!-- 区域层级 -->
        <FormItem prop="areaCodeNum" :label="$t('check.areaType')">
          <Select
            v-model="project.areaCodeNum"
            size="large"
            class="select-box"
            :disabled="areaDeviceData.length > 0"
            :title="
              areaDeviceData.length > 0 ? $t('updateNewSip.communityTip') : ''
            "
            @on-open-change="setAreaCode"
          >
            <Option v-for="i in 5" :key="i" :value="i">{{ i }}</Option>
          </Select>
          <span class="area-tip">
            <Icon type="md-help-circle" class="tip-icon" />
            {{ $t("check.example") }}
          </span>
        </FormItem>
        <!-- 区域描述 -->
        <FormItem prop="areaCodeDescription">
          <span slot="label">
            <span class="error-color">*</span>
            {{ $t("updateNewSip.areaNameTitle") }}
          </span>
          <div class="flex-box">
            <Input
              v-if="project.areaCodeNum >= 1"
              v-model="areaCodeDescription1"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              :placeholder="$t('check.areaNameTip')"
              size="large"
              maxlength="20"
              clearable
            ></Input>
            <Input
              v-if="project.areaCodeNum >= 2"
              v-model="areaCodeDescription2"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              :placeholder="$t('check.areaNameTip')"
              size="large"
              maxlength="20"
              clearable
            ></Input>
            <Input
              v-if="project.areaCodeNum >= 3"
              v-model="areaCodeDescription3"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              :placeholder="$t('check.areaNameTip')"
              size="large"
              maxlength="20"
              clearable
            ></Input>
            <Input
              v-if="project.areaCodeNum >= 4"
              v-model="areaCodeDescription4"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              :placeholder="$t('check.areaNameTip')"
              size="large"
              maxlength="20"
              clearable
            ></Input>
            <Input
              v-if="project.areaCodeNum >= 5"
              v-model="areaCodeDescription5"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
              :placeholder="$t('check.areaNameTip')"
              size="large"
              maxlength="20"
              clearable
            ></Input>
          </div>
        </FormItem>
      </Form>
      <div class="flex-box center-box">
        <Button
          type="primary"
          ghost
          class="footer-btn"
          size="large"
          @click="showImportModal"
        >
          {{ $t("deviceSip.importAddr") }}
        </Button>
        <Button
          type="primary"
          size="large"
          class="footer-btn"
          @click="setCurrentStep(1)"
        >
          {{ $t("deviceSip.next") }}
        </Button>
      </div>
    </div>
    <div class="content_win">
      <!-- 上传xml文件 -->
      <importModal ref="importModal" @updateTree="updateTree"></importModal>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import importModal from "./importModal";
export default {
  name: "communityConfig",
  components: {
    importModal,
  },
  filters: {},
  directives: {},
  mixins: {},
  props: {},
  data() {
    return {
      uploadTip: "", // 显示的文件名称
      project: {
        areaCodeDescription: [],
        areaCodeNum: 1,
        description: "",
        name: "",
      },
      areaCodeDescription1: "",
      areaCodeDescription2: "",
      areaCodeDescription3: "",
      areaCodeDescription4: "",
      areaCodeDescription5: "",
      fileObj: {},
      isFileTrue: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: this.$t("check.nameTip"),
            trigger: "blur",
          },
          {
            pattern: this.$store.state.common.nameReg,
            message: this.$t("check.nameError"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 50,
            message: this.$t("check.nameLength"),
            trigger: "blur",
          },
        ],
        area1: [
          {
            required: true,
            message: this.$t("check.areaNullTip"),
            trigger: "blur",
          },
          {
            pattern: this.$store.state.common.nameReg,
            message: this.$t("check.formateError"),
            trigger: "blur",
          },
        ],
        areaCodeNum: [
          {
            required: true,
            message: this.$t("check.noAreaTip"),
            trigger: "change",
            type: "number",
          },
        ],
        areaCodeDescription: [],
      },
      areaTypeNameList: [], // 区域信息list ，用于批量导入的
    };
  },
  computed: {
    ...mapState("projectConfig", ["projectInfo", "areaDeviceData"]),
  },
  watch: {},
  created() {
    this.setCommInfo();
  },
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    // 更新树组件的渲染
    updateTree(val) {
      this.uploadTip = val;
      // 给当前页面赋值
      this.setCommInfo();
    },
    // 上传xml文件，解析树形结构
    showImportModal() {
      this.$refs.importModal.importModal = true;
    },

    // 切换层级数据
    setAreaCode() {
      if (this.areaDeviceData.length > 0) {
        this.$Message.error(this.$t("updateNewSip.communityTip"));
        return false;
      } else {
        return true;
      }
    },
    // 设置小区信息
    setCommInfo() {
      debugger;
      if (Object.keys(this.projectInfo).length > 0) {
        this.project = this.projectInfo;
        this.project.areaCodeNum = Number(this.projectInfo.areaCodeNum);

        if (
          this.projectInfo &&
          this.projectInfo.areaCodeDescription.length > 0
        ) {
          let areaCodeDescription = this.projectInfo.areaCodeDescription.filter(
            (item) => item
          );
          this.areaCodeDescription1 = areaCodeDescription[0]
            ? areaCodeDescription[0]
            : "";
          this.areaCodeDescription2 = areaCodeDescription[1]
            ? areaCodeDescription[1]
            : "";
          this.areaCodeDescription3 = areaCodeDescription[2]
            ? areaCodeDescription[2]
            : "";
          this.areaCodeDescription4 = areaCodeDescription[3]
            ? areaCodeDescription[3]
            : "";
          this.areaCodeDescription5 = areaCodeDescription[4]
            ? areaCodeDescription[4]
            : "";

          localStorage.setItem("commLevel", this.project.areaCodeNum);
        }
      } else {
        localStorage.removeItem("commLevel");
      }
    },

    // 切换上下步骤
    // type:1=当前页面的下一步按钮进行跳转；0=通过步骤条快捷跳转
    setCurrentStep(type) {
      let isAllowToNext = false;
      let that = this;
      let areaCodeDescription = [
        this.areaCodeDescription1,
        this.areaCodeDescription2,
        this.areaCodeDescription3,
        this.areaCodeDescription4,
        this.areaCodeDescription5,
      ];
      let isValid = this.checkAreaDescription(areaCodeDescription);
      if (!isValid) {
        return;
      }

      this.$refs.project.validate((valid) => {
        if (valid) {
          areaCodeDescription = areaCodeDescription.filter((item) => item); // 去除空

          let projectObj = {
            areaCodeDescription: areaCodeDescription,
            areaCodeNum: that.project.areaCodeNum,
            description: that.project.description,
            name: that.project.name,
          };
          that.areaTypeNameList = areaCodeDescription.map((item, index) => {
            return {
              areaTypeName: item,
              areaTypeLevel: index + 1,
            };
          });

          // 设置全局区域描述
          that.$store.commit(
            "projectConfig/SET_AREATYPENAMELIST",
            that.areaTypeNameList
          );
          localStorage.setItem("commLevel", projectObj.areaCodeNum);

          // 设置全局项目信息
          that.$store.commit("projectConfig/SET_PROJECTINFO", projectObj);

          // 点击当前组件的下一步按钮，进行跳转；否则会重复回调卡顿
          if (type === 1) {
            that.$emit("setCurrentStep", 1);
          }
          isAllowToNext = true; // 是否允许下一步,用在步骤快速跳转处
        }
      });
      return isAllowToNext;
    },
    // 检查区域描述是否完整
    checkAreaDescription(areaCodeDescription) {
      let returnBoolean = true;
      let nameReg = this.$store.state.common.nameReg;
      for (let i = 0; i < this.project.areaCodeNum; i++) {
        if (areaCodeDescription.length === 0) {
          this.$Message.error(this.$t("updateNewSip.areaCodeDescriptionTip"));
          return false;
        }
        if (!areaCodeDescription[i]) {
          this.$Message.error(this.$t("updateNewSip.areaCodeDescriptionTip"));
          return false;
        }
        if (!nameReg.test(areaCodeDescription[i])) {
          this.$Message.error(this.$t("check.nameError"));
          return false;
        }
      }
      return returnBoolean;
    },
  },
};
</script>
<style lang="scss" scoped>
.communityConfig {
  width: 100%;
  height: 100%;
  padding: 50px 100px;
  background: #fff;

  .width-75 {
    width: 75%;
  }
  .select-box {
    width: 200px;
  }
}
.area-tip {
  position: absolute;
  color: #ed4014;
}
.flex-box {
  display: flex;
  & > div {
    margin-right: 20px;
  }
}
.relative-box {
  position: relative;
  cursor: pointer;
}

.opacity-box {
  position: absolute;
  top: 0;
  z-index: 9999;
  opacity: 0;
  cursor: pointer;
}
.footer-btn {
  margin-left: 20px;
  margin-top: 20px;
  text-align: center;
  padding: 5px 20px;
}
.center-box {
  justify-content: center;
}
</style>
